// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationPlaceholder_root__1VKnx","text":"NotificationPlaceholder_text__18e2D"};